import { useAppDispatch } from 'hooks';
import { settingsActions } from 'store/slices/mapV2/mapReducer/settingsSlice';
import { CoordinateSystems } from 'types';

export const CoordsModeTooltipOverlay = () => {
  const dispatch = useAppDispatch();

  return (
    <>
      <div
        className="px-4 tpg-c2 text-tpg_base hover:text-tpg_title select-none cursor-pointer"
        onClick={() =>
          dispatch(settingsActions.setCoordsMode(CoordinateSystems.WGS))
        }
      >
        WGS
      </div>
      <div
        className="px-4 tpg-c2 text-tpg_base hover:text-tpg_title select-none cursor-pointer"
        onClick={() =>
          dispatch(settingsActions.setCoordsMode(CoordinateSystems.SK42))
        }
      >
        СК42
      </div>
      <div
        className="px-4 tpg-c2 text-tpg_base hover:text-tpg_title select-none cursor-pointer"
        onClick={() =>
          dispatch(settingsActions.setCoordsMode(CoordinateSystems.USK2000))
        }
      >
        УСК2000
      </div>
    </>
  );
};
